import CreatePresentationVideoPage from "./CreatePresentationVideoPage";

export default CreatePresentationVideoPage;